export default __webpack_public_path__ + "static/media/new3.4e9a0f39.jpg";